









































import { Component, Vue } from 'vue-property-decorator'
import RadioImaged from '@/components/atoms/RadioImaged.vue'

const COLOR_BLACK = '#333333'
const COLOR_RED = '#DC361B'
const COLOR_HIGHLIGHT = '#EC8B4C'
@Component({
  components: {
    RadioImaged,
  },
})
export default class DrillPen extends Vue {
  private isDrawable = false
  private selectedValue = ''

  private get canvases() {
    return Vue.prototype.$penCanvases
  }

  private get canvaseKeys() {
    return Object.keys(this.canvases)
  }

  private changePen(e: Event): void {
    const target: any = e.target
    const val = target.value
    const elements = document.getElementsByName('drill__pen')
    if (this.selectedValue === '' || this.selectedValue !== val) {
      this.selectedValue = val
      this.setPenColor()
    } else {
      // 選択済みの場合は未選択にする
      Array.prototype.slice.call(elements).forEach((el) => {
        if (el.value === this.selectedValue) {
          el.checked = false
          this.selectedValue = ''
        }
      })
      this.canvaseKeys.forEach((name: any) => this.canvases[name].deactivateCanvas())
    }
    return
  }

  private setPenColor(): void {
    this.canvaseKeys.forEach((name: any) => this.canvases[name].activateCanvas())

    if (this.selectedValue === 'eraser') {
      this.canvaseKeys.forEach((name: any) => this.canvases[name].setEraser())
      return
    }

    let colorCode = ''
    let alpha = 1
    switch (this.selectedValue) {
      case 'black':
        colorCode = COLOR_BLACK
        break
      case 'red':
        colorCode = COLOR_RED
        break
      case 'highlight':
        colorCode = COLOR_HIGHLIGHT
        alpha = 0.01
        break
    }
    this.canvaseKeys.forEach((name: any) => this.canvases[name].changePenType({ colorCode, alpha }))
  }
}
